export default __webpack_public_path__ + "static/media/airtree.0a79f0ca.jpg";